import React from 'react';
import './App.css';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Evaluation from './components/Evaluation';
import Tools from './components/Tools';
import Feedback from './components/Feedback';
import Contact from './components/Contact';
import WhatsAppWidget from './components/WhatsAppWidget';
import Footer from './components/Footer';
import ScrollReveal from './components/ScrollReveal';

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <Navbar />
        <Hero />
        
        <ScrollReveal variant="fade-left" threshold={0.1}>
          <About />
        </ScrollReveal>

        <ScrollReveal variant="fade-up" threshold={0.08}>
          <Services />
        </ScrollReveal>

        <ScrollReveal variant="scale" threshold={0.08}>
          <Portfolio />
        </ScrollReveal>

        <ScrollReveal variant="fade-right" threshold={0.08}>
          <Evaluation />
        </ScrollReveal>

        <ScrollReveal variant="fade-up" threshold={0.1}>
          <Tools />
        </ScrollReveal>

        <ScrollReveal variant="scale" threshold={0.1}>
          <Feedback />
        </ScrollReveal>

        <ScrollReveal variant="fade-up" threshold={0.08}>
          <Contact />
        </ScrollReveal>

        <Footer />
        <WhatsAppWidget />
      </div>
    </ThemeProvider>
  );
}

export default App;


